
function modal_dialogue(submission_url, actions, title, message, extraFields = []){
    $('#modal_dialogue form').attr('action', submission_url);
    $('#modal_dialogue form input[name="actions"]').val(actions);
    $('#modal_dialogue .modal-title span').detach();
    $('#modal_dialogue .modal-title').append('<span>' + title + '</span>');
    $('#modal_dialogue .message').empty().append(message);

    $('#modal_dialogue form .extra-fields').empty();
    extraFields.forEach(f => {
        $('#modal_dialogue form .extra-fields').append('<input type="hidden" name="' + f.name + '" value="' + f.value + '">');
    });

    $('#modal_dialogue .control.ok').off('click').on('click', function(){
        $(this).attr('disabled', true);
        $('.control.cancel').attr('disabled', true);
        $('#modal_dialogue form').submit();
    });
    $('#modal_dialogue .control.cancel').off('click').on('click', function(){
        $('#modal_dialogue').modal('hide');
    });
    
    $('#modal_dialogue').modal();
}

window.modal_dialogue = modal_dialogue;
